import { actions } from "./actions";
import { ResultsReducer as reducer } from "./reducers";

const key = "results";

export {
  key,
  actions,
  reducer
};
